import { FC, ReactNode, useRef } from "react";

interface Props {
  children: ReactNode;
  tooltip?: string;
}

const ToolTip: FC<Props> = ({ children, tooltip }): JSX.Element => {
  const tooltipRef = useRef<HTMLSpanElement>(null);
  const container = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={container}
      onMouseEnter={({ clientX }) => {
        if (!tooltipRef.current || !container.current) return;
        const { left } = container.current.getBoundingClientRect();

        tooltipRef.current.style.left = clientX - left + "px";
      }}
      className="z-10 group relative inline-block"
    >
      {children}
      {tooltip ? (
        <span
          ref={tooltipRef}
                  className="text-[0.9rem] montserrat-small font-semibold rounded-md invisible group-hover:visible opacity-0 group-hover:opacity-100 transition 
          bg-lue-500 text-gray-400 border hover:rounded-md border-gray-600 p-1 px-2 absolute top-full mt-2 whitespace-nowrap"
        >
          {tooltip}
        </span>
      ) : null}
    </div>
  );
};

export default ToolTip;